import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuthStore from "components/core/Auth/useAuthStore";
import { PageContainer, ContentArea, HeaderBar, QuestionTitle, OptionsList, OptionCard, OtherInput, BottomActionWrapper, PrimaryButton, NoteTitle, NoteList, NoteItem, NoteIconWrapper, NoteText, ErrorText, CharCount } from "./styles";

const DeleteAccount = () => {
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [formState, setFormState] = useState({
    step: 1,
    selectedOption: "",
    otherReason: "",
  });
  const { step, selectedOption, otherReason } = formState;
  const options = [
    "I don't want to use Hyperpure anymore",
    "I am not running the business anymore",
    "I am not the POC for Hyperpure anymore",
  ];
  const updateState = (key, value) => {
    setFormState((prev) => ({ ...prev, [key]: value }));
  };
  const isContinueDisabled = !selectedOption || (selectedOption === "OTHER" && otherReason.trim().length < 25);
  useEffect(() => {
    if (selectedOption === "OTHER" && inputRef.current) {
      inputRef.current.focus();
    }
  }, [selectedOption]);


  const handleBack = () => {
    if (step === 2) updateState("step", 1);
    else navigate(-1);
  };

  const handleFirstStepContinue = () => {
    updateState("step", 2);
  };

  const sendDeleteAccountOtp = useAuthStore((state) => state.sendDeleteAccountOtp);

  const handleSendOTP = () => {
    const finalReason = selectedOption === "OTHER" ? otherReason : selectedOption;
    sendDeleteAccountOtp({ reason: finalReason });
    navigate("/delete-account/verify");
  };

  return (
    <PageContainer>
      <ContentArea>
        <HeaderBar onClick={handleBack}>
          <img src="/logos/back_logo.svg" alt="Back" width={20} height={20} />
          <span>Delete account</span>
        </HeaderBar>

        {step === 1 && (
          <>
            <QuestionTitle>Why do you want to delete your account?</QuestionTitle>
            <OptionsList>
              {options.map((option, index) => (
                <OptionCard
                  key={index}
                  $isSelected={selectedOption === option}
                  onClick={() => updateState("selectedOption", option)}
                >
                  {option}
                </OptionCard>
              ))}

              <OptionCard
                $isSelected={selectedOption === "OTHER"}
                onClick={() => updateState("selectedOption", "OTHER")}
              >
                {selectedOption === "OTHER" ? (
                  <OtherInput
                    ref={inputRef}
                    type="text"
                    placeholder="Enter your reason"
                    value={otherReason}
                    onChange={(e) => updateState("otherReason", e.target.value)}
                  />
                ) : (
                  "Other reason"
                )}
              </OptionCard>
              {selectedOption === "OTHER" && (
                <CharCount>{otherReason.trim().length}/25</CharCount>
              )}
            </OptionsList>

            <BottomActionWrapper $pt="24px">
              <PrimaryButton disabled={isContinueDisabled} onClick={handleFirstStepContinue}>
                Continue
              </PrimaryButton>
            </BottomActionWrapper>
          </>
        )}

        {step === 2 && (
          <>
            <NoteTitle>NOTE:</NoteTitle>
            <NoteList>
              <NoteItem>
                <NoteIconWrapper>
                  <img src="/logos/block_logo.png" alt="block" />
                </NoteIconWrapper>
                <NoteText>
                  You will not be able to access this account once it is deleted
                </NoteText>
              </NoteItem>

              <NoteItem>
                <NoteIconWrapper>
                  <img src="/logos/users_logo.png" alt="users" />
                </NoteIconWrapper>
                <NoteText>
                  Any other users associated with this account will not be deleted
                </NoteText>
              </NoteItem>

              <NoteItem>
                <NoteIconWrapper>
                  <img src="/logos/invoice_logo.svg" alt="invoice" />
                </NoteIconWrapper>
                <NoteText>
                  Your order & payment history will be retained for regulatory purposes
                </NoteText>
              </NoteItem>
            </NoteList>

            <BottomActionWrapper $pt="24px">
              <PrimaryButton onClick={handleSendOTP}>
                Continue to verify
              </PrimaryButton>
            </BottomActionWrapper>
          </>
        )}
      </ContentArea>
    </PageContainer>
  );
};

export default DeleteAccount;